import { Box } from '@bridebook/ui';
import { IconClass } from '@bridebook/ui/src/icons/constants';
import { TColor } from '@bridebook/ui/src/themes/types';
import componentStyles from './featured-marker.style';

export interface IProps {
  color?: TColor;
}

export const FeaturedMarker = ({ color = 'peachRose120' }: IProps) => {
  const styles = componentStyles({ color });

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.iconWrap}>
        <span className={IconClass.Hump} style={styles.humpIcon} />
        <span className={IconClass.FeaturedSupplier} style={styles.supplierIcon} />
      </Box>
      <Box style={styles.line} />
    </Box>
  );
};
